import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { setSelectedNode, setNodeById } from '../../../features/mainSlice';
import { color } from '../../../app/theme';
import GATip from './GATip';
import GAViewCondition from './GAViewCondition';
import Tooltip from '../../shared/Tooltip';
import icHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
      '& > img': {
        marginLeft: 4,
      },
    },
    add: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$2,
      cursor: 'pointer',
      marginTop: 12,
    },
    radio: {
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: color.$13,
    },
    radioInput: {
      fontSize: 15,
    },
    option: {
      margin: '12px 24px 12px 0',
    },
  },
  {
    name: 'GAView',
  },
);

const GAView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const isError = !!~isErrorNodeIds.indexOf(selectedNode?.id);
  const { data } = selectedNode || {};
  const { conditions } = data || {};

  const handleChangeCondition = (value, index) => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        conditions: conditions.map((condition, i) => {
          if (i === index) {
            return {
              ...condition,
              ...value,
            };
          }
          return condition;
        }),
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  const handleDeleteCondition = index => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        logicType: 'and',
        conditions: conditions.filter((c, i) => i !== index),
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  return (
    <>
      <div className={classes.root}>
        <div className={classes.title}>
          {t('GA.setting')}
          <Tooltip light placement="top" title={t('GA.settingTooltip')}>
            <img src={icHelpCircle} alt="help" />
          </Tooltip>
        </div>
        {conditions.map((c, i) => (
          <div key={`GAViewCondition-${i}`}>
            <GAViewCondition
              condition={c}
              isError={isError}
              isShowDelete={conditions.length >= 2}
              onChangeCondition={v => handleChangeCondition(v, i)}
              onDelete={() => handleDeleteCondition(i)}
            />
          </div>
        ))}
      </div>
      <GATip />
    </>
  );
};

export default GAView;
